import * as React from 'react';
import ReactInputMask from 'react-input-mask';
import cx from 'classnames';

import { InputChangeHandler } from 'types/typescript/eventHandlers';

import './styles/PhoneNumberMaskedInput.scss';

type OnChangeData = {
  formatted: string;
  raw: string;
};

type State = {
  value: string;
};

export type Props = {
  onBlur?: () => void;
  onChange?: (data: OnChangeData) => void;
  defaultValue?: string;
  value?: string;
  className?: string;
};

class PhoneNumberMaskedInput extends React.Component<Props, State> {
  state: State = {
    value: this.props.value || this.props.defaultValue || '',
  };

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.value !== nextProps.value) {
      this.setState({ value: nextProps.value || '' });
    }
  }

  handleChange: InputChangeHandler = (event) => {
    const controlled = this.props.value !== undefined;

    if (!controlled) {
      this.setState({ value: event.target.value || '' });
    }

    if (this.props.onChange) {
      this.props.onChange({
        formatted: event.target.value,
        raw: event.target.value ? event.target.value.replace(/[^0-9]/g, '') : '',
      });
    }
  };

  render() {
    const { className } = this.props;
    return (
      <ReactInputMask
        {...this.props}
        className={cx('MaskedInput', className)}
        mask="+1 999 999 9999"
        value={this.state.value}
        onChange={this.handleChange}
        onBlur={this.props.onBlur}
        maskChar={null}
      />
    );
  }
}

export { PhoneNumberMaskedInput };
export default PhoneNumberMaskedInput;
